import { assignmentsForChild } from './initialAssignments';
import { supabase } from './supabaseClient';

const CHILD_SELECT = 'id, name, grade, avatar_url, household_id, created_at, auth_user_id, archived_at';

/**
 * Insert a children row under an existing household and seed curriculum_assignments.
 * Does not create or modify households.
 */
export async function createChildWithAssignments({ householdId, name, grade }) {
  if (!householdId) {
    throw new Error('A household is required to add a child.');
  }

  const trimmedName = (name || '').trim();
  if (!trimmedName) {
    throw new Error('Enter your child’s name to continue.');
  }

  if (grade !== '7th') {
    throw new Error('The current pilot is available for 7th Grade.');
  }

  const { data: child, error: childError } = await supabase
    .from('children')
    .insert({
      household_id: householdId,
      name: trimmedName,
      grade
    })
    .select(CHILD_SELECT)
    .single();

  if (childError) throw childError;

  const { error: assignError } = await supabase
    .from('curriculum_assignments')
    .insert(assignmentsForChild(child.id));

  if (assignError) {
    await supabase.from('children').delete().eq('id', child.id);
    throw assignError;
  }

  return child;
}
